/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */
export const theme = {
	code: 'editor-code',
	heading: {
		h1: 'editor-heading-h1',
		h2: 'editor-heading-h2',
		h3: 'editor-heading-h3',
		h4: 'editor-heading-h4',
		h5: 'editor-heading-h5',
	},
	image: 'editor-image',
	link: 'editor-link',
	list: {
		listitem: 'editor-listitem',
		nested: {
			listitem: 'editor-nested-listitem',
		},
		ol: 'editor-list-ol',
		ul: 'editor-list-ul',
	},
	ltr: 'ltr',
	paragraph: 'editor-paragraph',
	placeholder: 'editor-placeholder',
	quote: 'editor-quote',
	rtl: 'rtl',
	text: {
		bold: 'editor-text-bold',
		code: 'editor-text-code',
		hashtag: 'editor-text-hashtag',
		italic: 'editor-text-italic',
		overflowed: 'editor-text-overflowed',
		strikethrough: 'editor-text-strikethrough',
		underline: 'editor-text-underline',
		underlineStrikethrough: 'editor-text-underlineStrikethrough',
	},
};
